import i18n from 'modules/core/lib/i18n'

export const TABS_IDS = {
  summary: 'summary',
  raw: 'raw',
}

export default () => [
  {
    active: true,
    id: TABS_IDS.summary,
    label: i18n.t('surveys.review.analytics.tabs.summary').toUpperCase(),
    color: 'brand',
  },
  {
    active: false,
    id: TABS_IDS.raw,
    label: i18n.t('surveys.review.analytics.tabs.raw').toUpperCase(),
    color: 'brand',
  },
]
